import { useEffect, useState } from 'react';
import devLogger from 'react-utils/devLogger';
// eslint-disable-next-line no-restricted-imports
import userInfo, { userInfoSync } from 'hub-http/userInfo';
export const useUserInfo = () => {
  const [userInfoResponse, setUserInfoResponse] = useState(() => {
    // Check if userInfo has already been loaded.
    try {
      return userInfoSync();
    } catch (__error) {
      devLogger.warn({
        message: `UBB-components-lib: Failure reading userinfo sync`,
        key: 'UBB-components-lib-userinfosync'
      });
    }
    return undefined;
  });
  useEffect(() => {
    if (userInfoResponse) {
      return;
    }
    try {
      // ignoreRedirect is important! Without it, any consumers of CDP that don't
      // support or shim userInfo can end up redirecting (the default behavior).
      // This has caused past critsits:
      // https://git.hubteam.com/HubSpot/Critsit/issues/3557
      // https://git.hubteam.com/HubSpot/Critsit/issues/1040
      userInfo({
        ignoreRedirect: true,
        cached: true
      }).then(response => {
        setUserInfoResponse(response);
      }).catch(() => {
        devLogger.warn({
          message: `UBB-components-lib: API failure fetching userinfo`,
          key: 'UBB-components-lib-userinfo-api'
        });
      });
    } catch (err) {
      devLogger.warn({
        message: `UBB-components-lib: Failure fetching userinfo`,
        key: 'UBB-components-lib-userinfo'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return userInfoResponse;
};